import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpMethodsService } from './http-methods.services';
import { PrizeRequestModel } from '../_models/prize-request.model';

export interface CreatePrizeRequestDto {
  prize_id: string;
  full_name: string;
  delivery_address?: string;
  city?: string;
  phone: string;
  email: string;
  additional_notes?: string;
  terms_accepted: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class PrizeRequestsService {
  constructor(private _httpService: HttpMethodsService) {}

  /**
   * Crear solicitud de canje
   * IMPORTANTE: Mapea respuesta a PrizeRequestModel
   */
  createRequest(dto: CreatePrizeRequestDto): Observable<PrizeRequestModel> {
    return this._httpService.post('prize_requests_create', dto).pipe(
      map((res: any) => new PrizeRequestModel(res))
    );
  }

  /**
   * Obtener mis solicitudes
   * IMPORTANTE: Mapea array de respuestas a PrizeRequestModel[]
   */
  getMyRequests(filters?: any): Observable<{ data: PrizeRequestModel[]; total: number }> {
    const queryParams: any = {};

    if (filters?.offset !== undefined) {
      queryParams.offset = filters.offset;
    }
    if (filters?.limit !== undefined) {
      queryParams.limit = filters.limit;
    }
    if (filters?.search) {
      queryParams.search = filters.search;
    }
    if (filters?.status) {
      queryParams.status = filters.status;
    }
    if (filters?.orderBy) {
      queryParams.orderBy = filters.orderBy;
    }
    if (filters?.order) {
      queryParams.order = filters.order;
    }

    return this._httpService.get('prize_requests_my', {}, queryParams).pipe(
      map((res: any) => ({
        data: res?.data?.map((r: any) => new PrizeRequestModel(r)) || [],
        total: res?.total || 0,
      }))
    );
  }

  /**
   * Obtener detalle de solicitud
   * IMPORTANTE: Mapea respuesta a PrizeRequestModel
   */
  getRequestDetail(id: string): Observable<PrizeRequestModel> {
    return this._httpService.get('prize_requests_detail', { id }).pipe(
      map((res: any) => new PrizeRequestModel(res))
    );
  }
}
